/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  FOLDER_CLEAN_REQUEST,
  FOLDER_SINGLE_CLEAN_REQUEST,
  FOLDER_UPSERT_REQUEST,
  FOLDER_UPSERT_REQUEST_SUCCESS,
  FOLDER_UPSERT_REQUEST_FAILURE,
  FOLDER_FETCH_REQUEST,
  FOLDER_FETCH_REQUEST_SUCCESS,
  FOLDER_FETCH_REQUEST_FAILURE,
  FOLDER_DOCUMENT_UPSERT_REQUEST,
  FOLDER_DOCUMENT_UPSERT_REQUEST_SUCCESS,
  FOLDER_DOCUMENT_UPSERT_REQUEST_FAILURE,
  FOLDER_DOCUMENT_FETCH_REQUEST,
  FOLDER_DOCUMENT_FETCH_REQUEST_SUCCESS,
  FOLDER_DOCUMENT_FETCH_REQUEST_FAILURE,
  FOLDER_DOCUMENT_CLEAN_REQUEST,
  FOLDER_DOCUMENT_SINGLE_CLEAN_REQUEST,
  FETCH_FOLDER_YEAR_WISE,
  FETCH_FOLDER_YEAR_WISE_SUCCESS,
  FETCH_FOLDER_YEAR_WISE_FAILURE,
  DELETE_FOLDER_REQUEST,
  DELETE_FOLDER_REQUEST_SUCCESS,
  DELETE_FOLDER_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  documentPayload: [],
  documentLoading: false,
  documentErrors: {},
  singleDocumentPayload: [],
  singleDocumentLoading: false,
  singleDocumentErrors: {},
  yearWiseFolder: [],
  yearWiseFolderLoading: false,
  yearWiseFolderErrors: {},
  deleteFolderPayload: [],
  deleteFolderLoading: false,
  deleteFolderErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const documentReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case FOLDER_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case FOLDER_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case FOLDER_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case FOLDER_UPSERT_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case FOLDER_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case FOLDER_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: [],
        singleErrors: action.error,
      });

    case FOLDER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case FOLDER_SINGLE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case FOLDER_DOCUMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        documentLoading: true,
      });

    case FOLDER_DOCUMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentLoading: false,
        documentPayload: action.data,
        documentErrors: {},
      });

    case FOLDER_DOCUMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentLoading: false,
        documentErrors: action.error,
        documentPayload: [],
      });

    case FOLDER_DOCUMENT_UPSERT_REQUEST:
      return Object.assign({}, state, {
        singleDocumentLoading: true,
      });

    case FOLDER_DOCUMENT_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleDocumentLoading: false,
        singleDocumentPayload: action.data,
        singleDocumentErrors: {},
      });

    case FOLDER_DOCUMENT_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleDocumentLoading: false,
        singleDocumentErrors: action.error,
        singleDocumentPayload: [],
      });

    case FOLDER_DOCUMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        documentPayload: [],
        documentLoading: false,
        documentErrors: {},
        singleDocumentPayload: [],
        singleDocumentLoading: false,
        singleDocumentErrors: {},
      });

    case FOLDER_DOCUMENT_SINGLE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleDocumentPayload: [],
        singleDocumentLoading: false,
        singleDocumentErrors: {},
      });

    case FETCH_FOLDER_YEAR_WISE:
      return Object.assign({}, state, {
        yearWiseFolderLoading: true,
      });

    case FETCH_FOLDER_YEAR_WISE_SUCCESS:
      return Object.assign({}, state, {
        yearWiseFolderLoading: false,
        yearWiseFolder: action.data,
        yearWiseFolderErrors: {},
      });

    case FETCH_FOLDER_YEAR_WISE_FAILURE:
      return Object.assign({}, state, {
        yearWiseFolderLoading: false,
        yearWiseFolderErrors: action.error,
        yearWiseFolder: [],
      });

    case DELETE_FOLDER_REQUEST:
      return Object.assign({}, state, {
        deleteFolderLoading: true,
      });

    case DELETE_FOLDER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteFolderLoading: false,
        deleteFolderPayload: action.data,
        deleteFolderErrors: {},
      });

    case DELETE_FOLDER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteFolderLoading: false,
        deleteFolderErrors: action.error,
      });

    default:
      return state;
  }
};

export default documentReducer;
